export const css = {
	root: '_20AYHxoO',
	iconWrapper: '_3Pdpo8Bd',
	statusIcon: '_1ihG3pWw',
	iconIcon: '_2LdqcoWj _29RvxPMs',
	actions: '_1Yt208g9',
	actionButtons: '_3_Ll2Y37',
	contentWrapper: '_3EYzd2Ak',
	content: '_3Vnat_CL',
	titleWrapper: '_1pE06Rea',
	title: '_1g7p1jlC',
	subtitle: '_3WenQ4-D',
	alert: 'Po1DdAhC',
	error: '_1P_-Ar_n',
	info: '_1bhlj_Fu',
	success: '_2KPVRlAC',
	' _key': 'certwise-theme/dojo/result'
};

export default css;
